import "vuetify/styles";
import { createApp } from "vue";
import { createVuetify } from "vuetify";

import App from "./App.vue";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const a55Theme = {
  dark: false,
  colors: {
    primary: "#3f88c9",
  },
};

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "a55Theme",
    themes: {
      a55Theme,
    },
  },
});
const app = createApp(App);

app.use(vuetify);

app.mount("#app");
